import { canv } from '@/canv/global.js'

export class propertyBuildEvent {

    constructor() {
    }

    init(UID, fixType, action, property) {
        this.event = {
            "type": "propertyBuild",
            "action": action,
            "UID": UID,
            "fixType": fixType,
            "property": property,
        };
    }

    execEvent() {
        var entity = canv.canvasController.FindByUID(this.event["UID"]);
        if (entity == null) return;

        entity.buildProperty(this.event["property"], this.event["fixType"], this.event["action"]);
    }

    checkEvent() {
        var entity = canv.canvasController.FindByUID(this.event["UID"]);
        if (entity == null) {
            return false;
        }

        return true;
    }

    getEvent() {
        return this.event;
    }

    loadEvent(event) {
        this.event = event;
    }

    getTwin() {
        let action = "add";
        if (this.event["action"] == "add") {
            action = "remove";
        }

        // тут возможно стоит заново искать стрелку (property) с нужным ключом, просто это очень узкий кейс

        let twin = new propertyBuildEvent();
        twin.init(this.event["UID"], this.event["fixType"], action, this.event["property"]);

        return twin;
    }





    event = {};


}